var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "#F7404E",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0.5C4.023 0.5 0 4.523 0 9.5C0 14.477 4.023 18.5 9 18.5C13.977 18.5 18 14.477 18 9.5C18 4.523 13.977 0.5 9 0.5ZM13.5 12.731L12.231 14L9 10.769L5.769 14L4.5 12.731L7.731 9.5L4.5 6.269L5.769 5L9 8.231L12.231 5L13.5 6.269L10.269 9.5L13.5 12.731Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/Cancel.22412be5.svg";
export { ForwardRef as ReactComponent };